import React from "react";
import { TableContentForRouteWiseCropDetails } from '../../../Common/Table/tableContent';
import tokenService from "../../../../Common/tokenDecoder";

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const reportData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const footerData = this.props.fData;

        return (
            <div>
                <h3><center><u>Leaf SUpplier Details Report</u></center></h3>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.factory}</div>
                    <div className="col"><b>Route: </b> {searchData.route === undefined ? "All Routes" : searchData.route}</div>
                    <div className="col"><b>Qty Range: from </b>{searchData.qtyTo} <b>to </b>{searchData.qtyFrom}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                    <div className="col"><b>Date/Time: </b> {new Date().toLocaleString()}</div>
                </div>
                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <table id="routeWiseCropDetails" className="display dataTable no-footer" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th>Reg. Number</th>
                                        <th>Reg Name</th>
                                        <th style={{ textAlign: "right" }}>Qty</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <TableContentForRouteWiseCropDetails
                                        data={reportData}
                                        contentRowNames={contentRowNames}
                                    />
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colSpan={2}>Total</th>
                                        <th style={{ textAlign: "right" }}>{footerData.netAmount.toFixed(2)}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}